import { StaticBaseDao } from '@/dao';
import { TrackingDevice, TrackingDeviceWithRaceContestantPosition } from '@/objects/generated';
import type { TrackingDeviceStatus } from './../enums/TrackingDeviceStatus';
import { useUserStore } from '@/stores';

export class TrackingDeviceDao extends StaticBaseDao {
    public static async SetDeviceState(devices: TrackingDevice[], status: TrackingDeviceStatus): Promise<TrackingDevice[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(
            TrackingDevice,
            `TrackingDevice/SetDeviceState` + '?' + (status == undefined ? '' : `status=${status}`),
            'POST',
            devices,
        );
    }
    public static async GetDevice(deviceId: number): Promise<TrackingDevice | null> {
        return this.BaseFetch(
            TrackingDevice,
            `TrackingDevice/GetDevice` + '?' + (deviceId == undefined ? '' : `deviceId=${deviceId}`),
            'GET',
        );
    }
    public static async GetDeviceByUniqueID(uniqueId: string | null): Promise<TrackingDevice | null> {
        return this.BaseFetch(
            TrackingDevice,
            `TrackingDevice/GetDeviceByUniqueID` + '?' + (uniqueId == undefined ? '' : `uniqueId=${uniqueId}`),
            'GET',
        );
    }
    public static async GetDeviceWithRaceContestants(EventId: number): Promise<TrackingDeviceWithRaceContestantPosition[]> {
        return this.BaseFetchArray(
            TrackingDeviceWithRaceContestantPosition,
            `TrackingDevice/GetDeviceWithRaceContestants` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'GET',
        );
    }
}
